import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'usb-key-point',
  templateUrl: './key-point.component.html',
  styleUrls: ['./key-point.component.scss']
})
export class KeyPointComponent implements OnInit {

  micitydest1 : any;
  mitexto1 : any;
  micitydest2 : any;
  mitexto2 : any;
  mitexto4 : any;
  mitexto3 : any;
  

  constructor() { }

  ngOnInit() {
  }

}
